import React from 'react';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import Table from 'components/data-visualization/Table/Table';
import { Head } from 'components/data-visualization/Table/SortingHead';
import Row from 'components/data-visualization/Table/Row';
import TableBody from 'components/data-visualization/Table/Body';

import {
  TableRow,
  TableCell,
} from 'components/data-containers/PositionsTable/shared/PositionsTable.style';
import { HeadCell } from 'components/data-containers/SocialFollowers/styles';
import { tableHeaders } from '../constants';

export const TableLoaderSkeleton: React.FC<{
  columnCount: number;
  isLargeScreen?: boolean;
}> = ({ columnCount, isLargeScreen }) => {
  return (
    <Table cellSpacing="0" cellPadding="0">
      {isLargeScreen && (
        <Head>
          <Row>
            {tableHeaders.map((header: any, index: number) => (
              <HeadCell key={`${header.value}-${index}`} colSpan={0}>
                {header.label}
              </HeadCell>
            ))}
          </Row>
        </Head>
      )}
      <TableBody>
        <TableLoader
          columnCount={columnCount}
          rowComponent={TableRow}
          cellComponent={TableCell}
        />
      </TableBody>
    </Table>
  );
};

const SkeletonLoader: React.FC<{ isLargeScreen?: boolean; title: string }> = ({
  isLargeScreen,
  title,
}) => {
  const columnCount = 4;

  return (
    <GenericComponent
      title={title}
      loading={true}
      success={false}
      showToolbarDropdown={false}
      isNarrowScreen
    >
      <AnimatedLoadingWrapper loading={true}>
        <TableLoaderSkeleton
          columnCount={columnCount}
          isLargeScreen={isLargeScreen}
        />
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
};

export default SkeletonLoader;
